import React from "react";
import PropTypes from "prop-types";
import Layout from "../components/Templates/Layout";
import Meta from "../utils/Meta";
import Banner from "../components/Hero/Banner";
import SmartText from "../utils/TextHandler";
import Image from "../components/Global/Image";
import Gallery from "../components/Sections/SectionGallery";
import CardGameDetails from "../components/Cards/CardGameDetails";
import SectionSignatures from "../components/Sections/SectionSignatures";

// ====

const Game = (props) => {
  const { pageContext, blok } = props;
  let doc;
  if (pageContext) {
    doc = JSON.parse(pageContext.story.content);
  } else {
    doc = blok;
  }
  const openGraph = {
    type: "website",
    title: doc.title,
    description: doc.body,
    image: doc.image,
  };

  return (
    <Layout>
      <Meta openGraph={openGraph} meta={doc.meta} />
      <Banner
        title={doc.title && doc.title}
        image={doc.background_letterbox && doc.background_letterbox}
        logo={doc.logo && doc.logo}
      />
      <section className="py-5">
        <div className="container">
          <div className="row justify-content-between">
            <div className="col-12 col-lg-7 mb-5 mb-lg-0">
              {doc.gallery && <Gallery items={doc.gallery} />}
              {doc.body && <SmartText>{doc.body}</SmartText>}
              {doc.features && (
                <div className="brand-background-grey p-5 mt-5 brand-radius brand-shadow">
                  <h3 className="brand-font m-0 mb-3">Features</h3>
                  <SmartText>{doc.features}</SmartText>
                </div>
              )}
            </div>
            <div className="col-12 col-lg-4">
              <CardGameDetails item={doc} />
            </div>
          </div>
        </div>
      </section>
      {doc.signatureedition && (
        <SectionSignatures items={doc.signatureedition} />
      )}
    </Layout>
  );
};

export default Game;
